import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  myCompany () {
    return api().get(`company`)
  },
  updateMyCompany ({ item }) {
    return api().put(`company`, item)
  },
  childCompanies () {
    return api().get(`company/child_companies`)
  },
  childCompany ({ id }) {
    return api().get(`company/child_companies/${id}`)
  },
  createCompany ({ item }) {
    return api().put(`company/child_companies`, item)
  },
  updateCompany ({ item }) {
    return api().put(`company/child_companies/${item.id}/data`, item)
  },
  setCompanyActiveStatus ({ id, status }) {
    return api().put(`company/child_companies/${id}/status`, status)
  },
  childCompanyUsers ({ parentCompanyId, childCompanyId }) {
    return api().get(`company/child_companies/${childCompanyId}/users`)
  },
  businessRegister ({ query }) {
    return api().get(`business_register?search=${query}`)
  },
  getClient ({ clientId, invoiceId }) {
    let url = `company/clients/${clientId}`
    if (invoiceId) {
      url += `?invoice=${invoiceId}`
    }
    return api().get(url)
  },
  addClient ({ data }) {
    return api().put(`company/clients`, data)
  },
  takeCompanyIdentity ({ id }) {
    return api().post(`company/identity`, { company: id })
  },
  handleInvoiceDuplicate ({ id, accept }) {
    return api().put(`company/invoice_duplicates`, { id, accept })
  },
  invoiceConsistency () {
    return api().get(`company/invoice_consistency_data`)
  },
  invoiceDuplicates (invoice) {
    return api().get(`company/invoice_duplicates?invoice=${invoice}`)
  },
  getCountries () {
    return api().get(`countries`)
  },
  getElectronicDeviceListForDealer ({ startDate, endDate }) {
    return api().get(`company/electronic_device_list/xlsx?dateFrom=${startDate}&dateTo=${endDate}`)
  },
  getCreateMaterialDiaryPdfReport ({ businessUnitId, startDate, endDate }) {
    return api().get(`company/business_units/${businessUnitId}/material_diary/pdf?dateFrom=${startDate}&dateTo=${endDate}`)
  },
  getCreateArticleDiaryPdfReport ({ businessUnitId, startDate, endDate, filters }) {
    return api().get(`company/business_units/${businessUnitId}/article_diary/pdf?dateFrom=${startDate}&dateTo=${endDate}&${objectToQueryString(filters)}`)
  },
  getArticleDiary ({ businessUnitId, startDate, endDate }) {
    return api().get(`company/business_units/${businessUnitId}/article_diary?dateFrom=${startDate}&dateTo=${endDate}`)
  }
}
